module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar customNavbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.root()
      }
    }
  }, [_c('img', {
    staticClass: "logoClass",
    attrs: {
      "src": "/static/logo.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-end"
  }, [_c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.root()
      }
    }
  }, [_vm._v("Inicio")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.about()
      }
    }
  }, [_vm._v("Nosotros")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.products()
      }
    }
  }, [_vm._v("Productos")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.news()
      }
    }
  }, [_vm._v("Noticias")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.contact()
      }
    }
  }, [_vm._v("Contacto")]), _vm._v(" "), (_vm.isLogged) ? _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Cerrar Sesión")]) : _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("Iniciar Sesión")])])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "column is-two-thirds"
  }, [_c('h2', {
    staticClass: "title is-2"
  }, [_vm._v("Resultados de búsqueda")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "field has-addons"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('searchText')
    },
    attrs: {
      "type": "text",
      "name": "searchText"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('searchText')),
      expression: "errors.has('searchText')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('searchText')))])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button customButton",
    on: {
      "click": _vm.searchAgain
    }
  }, [_vm._v("Buscar")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  })]), _vm._v(" "), _vm._l((_vm.searchList), function(searchItem) {
    return _c('article', {
      staticClass: "message is-info"
    }, [_c('div', {
      staticClass: "message-body"
    }, [_c('div', {
      staticClass: "searchContent",
      staticStyle: {
        "height": "70px"
      }
    }, [_c('h2', {
      staticClass: "searchTitle"
    }, [_c('i', [_c('b', [_vm._v(_vm._s(searchItem.description))])])]), _vm._v(" "), _c('a', {
      staticClass: "newsLink",
      staticStyle: {
        "margin-top": "30px"
      },
      on: {
        "click": function($event) {
          _vm.searchDetail(searchItem.link)
        }
      }
    }, [_vm._v("Ver más")])])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "column"
  })])]), _vm._v(" "), _c('FooterComponent')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a12feb4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchComponent.vue
// module id = 86
// module chunks = 0